import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class ConciliacaoMovimentoEntidadeService {

  getCaixaMovimentosEConciliacaoSaldo(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/visualizamovimentoeconciliacaosaldo', item, { observe: 'response' })
  }

  postSalvarConciliacao(item: any, pesquisa: any): Observable<HttpResponse<any>> {
    const body = {
      conciliacoes: item,
      filtropesquisa: pesquisa
    };

    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/conciliacao', body, { observe: 'response' }
    );
  };

  postConciliarContasMapeadas(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/conciliarcontasmapeadas', item, { observe: 'response' }
    )
  }

  getConciliacoesPendentes(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/visualizaconciliacoes', item, { observe: 'response' }
    );
  }

  putDesfazerConciliacao(item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/desfazconciliacao', item, { observe: 'response' }
    );
  }

  getConciliacaoSaldoDia(caixaId, itemTipo: any): Observable<HttpResponse<any>> {
    const params = {
      caixaId: caixaId
    };
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/visualizaconciliacaosaldodia/' + itemTipo, {params: params, observe: 'response'}
    )
  }

  postConciliacaoSaldoDia(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/incluiconciliacaosaldodia', item, {observe: 'response'}
    )
  }

  postMapeiaConciliacaoMovimentoEntidade(itemId:any, item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/mapeiacontaconciliacaomovimentoentidade/' + itemId, item, {observe: 'response'}
    )
  }

  postConciliacaoMovimentoEntidade(itemId:any, item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/incluiconciliacaoentidade/' + itemId, item, {observe: 'response'}
    )
  }

  getConciliacaoMovimentoEntidade(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/visualizatodas/' + itemId, {observe: 'response'}
    )
  }

  deleteConciliacaoMovimentoEntidade(itemId: any): Observable<HttpResponse<any>> {
    return this.http.delete(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/excluiconciliacaoentidade/' + itemId, {observe: 'response'}
    )
  }

  putConciliacaoMovimentoEntidade(itemId: any, item): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/atualizaconciliacaoentidade/' + itemId, item,{observe: 'response'}
    )
  }

  atualizaStatusConciliacaoMovimento(itemId: any, item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/atualizastatus/' + itemId, item, {observe: 'response'}
    )
  }

  verificaBoletoAtivoContasMapeadas(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conciliacaomovimentoentidade/verifica-boleto-ativo', item, {observe: 'response'}
    )
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
